import { adminFetch } from "./_client";
import type { BookingCalcSuggestion, BookingCalcConfigResponse, InsuranceCalcResult } from "./types";


export function fetchBookingCalcSuggestion(token: string, id: number) {
  return adminFetch<{ suggestion: BookingCalcSuggestion }>(`/admin/booking-calculator/suggestion/${id}`, token);
}


export function fetchBookingCalcInsuranceConfig(token: string) {
  return adminFetch<BookingCalcConfigResponse>(`/admin/booking-calculator/insurance-config`, token);
}


export function calculateBookingInsurance(
  token: string,
  data: {
    insured_value: number;
    rental_days: number;
    rental_hours: number;
    rental_hours_with_insurance: number;
    rental_type: string;
    rate_type?: string;
    insurance_package_id: number;
    insurance_package_name: string;
    state_code: string;
    category?: string;
    discount_override?: number;
  },
) {
  return adminFetch<{ result: InsuranceCalcResult }>(`/admin/booking-calculator/calculate`, token, {
    method: "POST",
    body: JSON.stringify(data),
  });
}


export function writeBookingCalcInsurance(
  token: string,
  suggestionId: number,
  data: {
    insurance_fee: number;
    insurance_liability_cost: number;
    insurance_physical_cost: number;
    insurance_package: number;
    insurance_package_name: string;
  },
) {
  return adminFetch<{ success: boolean; changes: unknown }>(`/admin/booking-calculator/suggestion/${suggestionId}/insurance`, token, {
    method: "POST",
    body: JSON.stringify(data),
  });
}
